import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en/translation.json';
import idTranslation from './locales/id/translation.json';
import cnTranslation from './locales/cn/translation.json';

// Fetch available languages from API
const fetchLanguages = async () => {
  try {
    const response = await fetch('https://xianhefairy.com/LotusFairy_API/api/SiteContent/GetLanguages');
    const languages = await response.json();
    // return languages;
    // Filter out Chinese (id: 2226)
    // console.log('Raw languages from API:', languages); // Debug: see raw data
    // Filter out Chinese (id: 2226) - check both Id and id properties
    const filtered = languages.filter(lang => {
      const langId = lang.Id || lang.id;
      return langId !== 2226;
    });
    // console.log('Filtered languages:', filtered); // Debug: see filtered result
    return filtered;
  } catch (error) {
    console.error('Failed to fetch languages:', error);
    return [];
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      id: { translation: idTranslation },
      cn: { translation: cnTranslation }
    },
    lng: localStorage.getItem('language') || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
export { fetchLanguages };